module.exports = __webpack_public_path__ + "static/img/7.2f83fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/7.jpg
// module id = Fbld
// module chunks = 2